export const skillsData = [
    {
      label: "LANGUAGES",
      data: [
        {
          skillName: "HTML",
          percentage: "90",
        },
        {
          skillName: "CSS",
          percentage: "80",
        },
        {
          skillName: "Javascript",
          percentage: "80",
        },
        {
          skillName: "C++",
          percentage: "80",
        },
      ],
    },
    {
      label: "LIBRARY/FRAMEWORK",
      data: [
        {
          skillName: "React.js",
          percentage: "80",
        },
        {
          skillName: "Express.js",
          percentage: "80",
        },
        {
          skillName: "Node.js",
          percentage: "80",
        },
        {
          skillName: "NextJS",
          percentage: "70",
        },
      
      ],
    },
    {
      label: "DATABASES",
      data: [
        {
          skillName: "SQL",
          percentage: "70",
        },
        {
          skillName: "MongoDB",
          percentage: "80",
        },
        {
          skillName: "Firestore",
          percentage: "90",
        },
        // {
        //   skillName: "ORACLE",
        //   percentage: "85",
        // },
      ],
    },
    {
      label: "OTHERS",
      data: [
        {
          skillName: "Docker",
          percentage: "90",
        },
        {
          skillName: "Kubernetes",
          percentage: "90",
        },
        {
          skillName: "git",
          percentage: "90",
        },
        {
          skillName: "github",
          percentage: "85",
        },
        {
          skillName: "SEO",
          percentage: "30",
        },
        {
          skillName: "Hosting",
          percentage: "60",
        },
        {
          skillName: "Deployment",
          percentage: "40",
        },
        
      ],
    },
  ];